import React, { Component } from 'react';
import PropTypes from 'prop-types';
import "./styles/Tab.css";
class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tabKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    const { tabKey, label, onClick } = this.props;
    onClick(tabKey != null ? tabKey : label);
  }

  render() {
    const {
      onClick,
      props: {
        activeTab,
        tabKey,
        label,
      },
    } = this;

    const id = tabKey != null ? tabKey : label;
    let className = 'tab-list-item';

    if (activeTab === id) {
      className += ' tab-list-active';
    }

    return (
      <strong
        className={className}
        onClick={onClick}
      >
        {label}
      </strong>
    );
  }
}

export default Tab;